import * as React from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import UploadIcon from '@mui/icons-material/Upload';
import SaveIcon from '@mui/icons-material/Save';
import Box from '@mui/material/Box';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { useQuery } from '../hooks/useQuery';
import { useSnackbar } from '../hooks/useSnackbar';
import CustomizedDialogs from '../components/ModalAlert';
import DemaisArquivosItem from '../components/DemaisArquivosItem';
import { useAuth } from '../hooks/useAuth';
import { useNavigate, useSearchParams } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import { handleHttpError, isFileBig } from '../utils';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useTheme } from '@mui/material/styles';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { FormControl } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import ArticleIcon from '@mui/icons-material/Article';
import moment from 'moment';

const TIPO_ARQUIVOS_PERMITIDOS = ['pdf'];

export const InformeRendimentosPage = () => {
  const [file, setFile] = React.useState([]);
  const [isUpdating, setIsUpdating] = React.useState(false);
  const [messageError, setMessageError] = React.useState('');
  const [showDialogError, setShowDialogError] = React.useState(false);
  const [show, setShow] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [message, setMessage] = React.useState('');
  const [type, setType] = React.useState('');
  const { user, isUsuarioSebrae } = useAuth();
  const navigate = useNavigate();
  const snackbar = useSnackbar();
  const theme = useTheme();
  const [ordensErro, setOrdensErro] = React.useState([]);
  const [isHtml, setIsHtml] = React.useState(false);
  const [informeRendimentos, setInformeRendimentos] = React.useState([]);
  const {
    listarInformeRendimentos,
    enviarInformeRendimentos,
    downloadInforme,
  } = useQuery();

  React.useEffect(() => {
    if (!isUsuarioSebrae) {
      fetchFiles();
    }
  }, []);

  const fetchFiles = async () => {
    const response = await listarInformeRendimentos();
    setInformeRendimentos(response.data.data);
  };

  const sendFile = async (arquivos) => {
    setIsUpdating(true);
    const formData = new FormData();

    arquivos.map((res, i) => {
      formData.append(i, res);
    });

    formData.append('qtn', arquivos.length);
    try {
      await enviarInformeRendimentos(formData);
      setShow(true);
      setMessage('Upload de informe rendimentos finalizado com sucesso');
      setType('success');
    } catch (error) {
      snackbar.showSnackbar('Formato do nome do aquivo inválido.');
    } finally {
      setIsUpdating(false);
      setFile([]);
    }
  };

  React.useEffect(() => {
    if (file && file.length > 0) {
      sendFile(file);
    }
  }, [file]);

  const handleButtonOk = () => {
    setShow(false);

    // navigate(
    //   `/dashboard/notas/${contratoId}?cnpj=${cnpj}&is_contract=${isContract}&contrato_dts=${contratoDts}&gestor=${searchParams.get("gestor")}`
    // );
  };

  const onChangeFile = (event) => {
    const files = [...event.target.files];

    if (files.length > 0) {
      let filesToSend = [];
      files.forEach((file) => {
        const extension = file.name.split('.').pop();

        if (!TIPO_ARQUIVOS_PERMITIDOS.includes(extension.toLowerCase())) {
          snackbar.showSnackbar(
            'Tipo de arquivo inválido. Somente ' +
              TIPO_ARQUIVOS_PERMITIDOS.join(','),
          );
          setFile([]);
          return;
        }

        if (isFileBig(file.size)) {
          snackbar.showSnackbar('Tamanho de arquivo inválido. Máximo é 10MB');
          return;
        }

        filesToSend.push(file);
      });

      setFile(filesToSend);
    }
  };

  async function downloadPdf(ano, cnpj) {
    const result = await downloadInforme(`?cnpj=${cnpj}&ano=${ano}`);
    const linkSource = `data:application/pdf;base64,${result.data}`;
    const downloadLink = document.createElement('a');
    downloadLink.href = linkSource;
    downloadLink.download = `informe_rendimentos${ano}.pdf`;
    downloadLink.click();
  }

  const clickDetalheModal = () => {
    setMessage(ordensErro && ordensErro.length > 1 && ordensErro[1]);
    setOrdensErro([]);
    setIsHtml(false);
    setType('error');
    setShow(true);
  };

  return (
    <Box
      mt={8}
      sx={{ width: '100%', minHeight: '100vh' }}
      backgroundColor="#FAFCFF"
    >
      <AppBar position="static" color={'primary'} style={{ padding: 10 }}>
        <Grid container>
          <Grid
            item
            xs={12.5}
            alignItems="center"
            display="flex"
            justifyContent="space-between"
          >
            <Grid item display="flex" alignItems="center">
              <ArticleIcon
                sx={{
                  fontSize: 40,
                }}
              />
              <span style={{ color: 'white', fontSize: 20 }}>
                Informe Rendimentos
              </span>
            </Grid>
          </Grid>
        </Grid>
      </AppBar>
      {isUsuarioSebrae ? (
        <Card
          variant="outlined"
          style={{
            borderTop: `8px solid ${theme.palette.primary.light}`,
            marginTop: '2rem',
          }}
        >
          <CardContent>
            <CustomizedDialogs
              content={messageError}
              btnTxt={'Ok'}
              type="error"
              onClick={() => setShowDialogError(false)}
              handleClose={setShowDialogError}
              visible={showDialogError}
              ordens={ordensErro}
              isHtml={isHtml}
              onClickDetalhe={clickDetalheModal}
            />
            <CustomizedDialogs
              content={message}
              btnTxt={'Ok'}
              type={type}
              onClick={handleButtonOk}
              handleClose={setShow}
              visible={show}
            />
            <Grid style={{ marginTop: 10 }} container spacing={2}>
              <Grid item sm={12}>
                <p
                  style={{ color: '#0e72b8', marginTop: 0, fontWeight: 'bold' }}
                >
                  Importar informe de rendimentos (EX.: cnpj_ano.pdf)
                </p>
              </Grid>
              <Grid item sm={10}>
                <TextField
                  disabled
                  style={{ width: '100%' }}
                  id="outlined-basic"
                  value={(file && file.name) || ''}
                  placeholder="Importar arquivos"
                  variant="outlined"
                />
              </Grid>
              <Grid item sm={2}>
                <Button
                  style={{ width: '100%', height: 40 }}
                  variant="outlined"
                  component="label"
                  disabled={isUpdating}
                >
                  <UploadIcon />
                  Importar
                  <input
                    onChange={onChangeFile}
                    hidden
                    multiple
                    accept={TIPO_ARQUIVOS_PERMITIDOS.join(',')}
                    type="file"
                  />
                </Button>
              </Grid>
            </Grid>
            {isUpdating ? (
              <CircularProgress color={'inherit'} size={25} />
            ) : null}
            <br />
          </CardContent>
        </Card>
      ) : (
        <Card
          variant="outlined"
          style={{
            borderTop: `8px solid ${theme.palette.primary.light}`,
            marginTop: '2rem',
          }}
        >
          <Grid style={{ marginTop: 10 }} container spacing={2}>
            <Grid item sm={12}>
              <p
                style={{
                  color: '#0e72b8',
                  marginTop: 0,
                  marginLeft: 15,
                  fontWeight: 'bold',
                }}
              >
                Visualizar Informe de Rendimentos
              </p>
            </Grid>
            {informeRendimentos &&
              informeRendimentos.length > 0 &&
              informeRendimentos.map((res) => {
                return (
                  <Grid item sm={12}>
                    <Button
                      variant="contained"
                      onClick={() => {
                        downloadPdf(res.ano, res.cnpj);
                      }}
                      style={{ width: '20%', margin: 20 }}
                    >
                      <p
                        style={{
                          color: '#0e72b8',
                          margin: 0,
                          fontWeight: 'bold',
                        }}
                      >
                        {res.ano}
                      </p>
                    </Button>
                    <span>
                      Versão: {res.version} |{' '}
                      {moment(res.updated_at).format('DD/MM/YYYY HH:mm')}
                    </span>
                  </Grid>
                );
              })}
          </Grid>
        </Card>
      )}
    </Box>
  );
};
